exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".expandable-card-wrapper{position:relative;z-index:999}.expandable-card{position:absolute;width:100%;left:0;top:0;z-index:999;overflow:hidden}.expand-in{animation:expand-in .2s;animation-fill-mode:forwards}.collapse-out{animation:collapse-out .15s;animation-fill-mode:forwards;animation-delay:.13s}@keyframes expand-in{0%{box-shadow:0 0 0 rgba(0,0,0,.19),0 0 0 rgba(0,0,0,.23)}to{box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)}}@keyframes collapse-out{0%{box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)}to{box-shadow:0 0 0 rgba(0,0,0,.19),0 0 0 rgba(0,0,0,.23)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/ExpandableCard/ExpandableCard.scss
// module id = 849
// module chunks = 0